import * as mock from "../mocks/users.mock.js";

export function listUsers() {
  return mock.listUsers();
}

export function listUserPermissions(userId) {
  return mock.listUserPermissions(userId);
}

export function updateUserStatus(userId, status) {
  return mock.updateUserStatus(userId, status);
}

export function updateUserPermissions(userId, permissions) {
  return mock.updateUserPermissions(userId, permissions);
}

export { AVAILABLE_PERMISSIONS } from "../mocks/users.mock.js";
